import React, { useState, useEffect, useRef } from 'react'
import { useParams, useNavigate } from 'react-router-dom';
import { Button, Form }  from 'react-bootstrap';
import {  useSelector, useDispatch } from 'react-redux'
import { LinkContainer } from 'react-router-bootstrap';
import { useGetPublicplanQuery } from '../../slices/teachers/planApiSlice';
import { useSubscribeMutation, useUpdateMutation, useSubscribeinstripeMutation } from '../../slices/students/studentsApiSlice';
import { setStudentCredentials } from '../../slices/students/authStudentSlice';
import { toast } from 'react-toastify';
import StudentHeader from '../../components/StudentHeader';
import StudentNavbar from '../../components/StudentNavbar';
import Loader from '../../components/Loader';
import Message from '../../components/Message';
import PublicPlan from '../../components/PublicPlan';

const StudentsManage = () => {

    const navigate = useNavigate();

    const dispatch = useDispatch();

    const { id } = useParams();

    const [myplans, setMyplans] = useState([]);
    const [questions, setQuestions] = useState([]);
    const [subject, setSubject] = useState();
    const [isCancel, setIsCancel] = useState(true);
    const [cancelId, setCancelId] = useState();
    const [enroll, setEnroll] = useState(false);
    const [upgrade, setUpgrade] = useState(false);
    const [qleft, setQleft] = useState();
    const [paysetup, setPaysetup] = useState('');

    const { data: plansData, error: plansError, isLoading: plansIsLoading } = useGetPublicplanQuery(id);

    const [subscribe, { isLoading: loadingSubscribe }] = useSubscribeMutation();

    const [update, { isLoading: loadingUpdateSubscribe }] = useUpdateMutation();

    const { studentInfo } = useSelector((state) => state.authStudent);

    useEffect(() => {
        if(!studentInfo) {
            navigate('/studentlogin')
        }
    }, [navigate, studentInfo])

    useEffect(() => {
        if (studentInfo.questions) {
            setMyplans([...studentInfo?.questions]);
        }
      }, [studentInfo?.plan]);

    useEffect(() => {
        myplans.map((pla) => {
            if (pla.plan == id && pla.renewal == true) {
                setEnroll(true)
            }
        });
        setQuestions(plansData?.plan.totalQuestions)
        setSubject(plansData?.plan.subject)
        setPaysetup(plansData?.isPaymentSetup)
    }, [myplans, plansData]);


    useEffect(() => {
        if (subject) {
        myplans.map((pla) => {
            if (pla.subject == subject && pla.renewal == true && pla.plan != id) {
                console.log(pla)
                setQleft(pla.questionsLeft)
                setUpgrade(true)
                setCancelId(pla.plan)
            }
        });
    }
    }, [myplans, subject]);

    const upgradeHandler = async (e) => {
        e.preventDefault()
        try {
            const res = await update({ plans: myplans,  id, qleft, cancelId, subject, questions  }).unwrap();
            dispatch(setStudentCredentials({ ...res }));
            toast.success('Upgrade Successfully');
            navigate('/studentasknew')
        } catch (err) {
            toast.error(err?.data?.message || err.error.message);
        }
    }

    const subscribeHandler = async (e) => {
        e.preventDefault()
        try {
            const res = await subscribe({ plans: myplans,  id, subject, questions  }).unwrap();
            dispatch(setStudentCredentials({ ...res }));
            toast.success('Subscribed Successfully');
            navigate('/studentasknew')
        } catch (err) {
            toast.error(err?.data?.message || err.error.message);
        }
    }

    const cancelSubscribtionHandler = async (e) => {
        e.preventDefault()
        try {
            const res = await subscribe({ plans: myplans, id, subject, questions, isCancel  }).unwrap();
            dispatch(setStudentCredentials({ ...res }));
            toast.success('Subscription Cancelled');
            navigate('/studentsubscriptions')
        } catch (err) {
            toast.error(err?.data?.message || err.error.message);
        }
    }

  return (
    <div>
        <StudentNavbar />
        <div className="main-content" id="panel">
            <StudentHeader /><br />
            <div className="container-fluid mt--5 loginResponsive"><br />                 
                <div className="container mt--10 pb-5 containerP">
                    <div className="row bg-gradient-defaultt titleContainerP">
                            <h3 className=" tittleColor4 "><br />
                                <span className='tittleColor4'>
                                Subscribe or cancel a plan                                 
                                </span>
                            </h3><br />
                            {plansIsLoading ? ( 
                                <Loader />
                            ) : plansError ? (
                                <Message variant='danger'>
                                    {plansError?.data?.message || plansError.error}
                                </Message>
                            ) : (
                                <div className=" offset-lg-1 col-lg-5 text-center"><br />
                                    <div className={`card card-pricing bg-gradient-primary shadow-lg rounded border-0 text-center mb-4` }>
                                        <div className="card-header bg-transparent">
                                            <h4 className="text-uppercase ls-1 text-white py-3 mb-0">Learning Plan</h4>
                                        </div>
                                        <div className="card-body px-lg-5">
                                            <div className="display-4 text-white">${plansData?.plan.price}</div>
                                            <span className="text-white">monthly</span>
                                            <ul className="list-unstyled my-4">
                                                <li>
                                                    <div className="d-flex align-items-center">
                                                    <div>
                                                        <div className="icon icon-xs icon-shape bg-white shadow rounded-circle text-muted">
                                                        <i className="fas fa-check"></i>
                                                        </div>
                                                    </div>
                                                    <div>
                                                        <span className="pl-1 text-white">You can ask up to {plansData?.plan.totalQuestions} monthly questions </span>
                                                    </div>
                                                    </div>
                                                </li><br />
                                                <li>
                                                    <div className="d-flex align-items-center">
                                                    <div>
                                                        <div className="icon icon-xs icon-shape bg-white shadow rounded-circle text-muted">
                                                        <i className="fas fa-check"></i>
                                                        </div>
                                                    </div>
                                                    <div>
                                                        <span className="pl-2 text-white">Each Question can <br /> &nbsp; &nbsp; last up to 5 minutes</span>
                                                    </div>
                                                    </div>
                                                </li>
                                                <li>
                                                    <div className=" align-items-center">                                                  
                                                        <div><br />
                                                        <Form onSubmit={cancelSubscribtionHandler}>
                                                        { enroll ? 
                                                            <Button type="submit" className="btn btn-block btn-info bg-gradient-info">Cancel Subscribtion</Button>
                                                            : 
                                                            <p className='text-white display-6'></p>
                                                        }
                                                        </Form>
                                                        </div>
                                                    </div>
                                                </li>
                                            </ul>
                                        </div>
                                        <div className="card-footer bg-transparent card-footer2">
                                        </div>
                                    </div>    
                                </div>
                            )} 
                            <div className="  col-lg-5 text-center"><br />
                                <div className="card bg-gradient-primary">
                                <div className="card-body"><br /><br /><br />
                                <div className="row justify-content-between align-items-center">
                                    <div className="col">
                                    <img src="../assets/img/icons/cards/mastercard.png" alt="Image placeholder" />
                                    </div>
                                    <div className="col-auto">
                                    <div className="d-flex align-items-center">
                                        <small className="text-white font-weight-bold mr-3">Make default</small>
                                        <div>
                                        <label className="custom-toggle  custom-toggle-white">
                                            <input type="checkbox" checked="" />
                                            <span className="custom-toggle-slider rounded-circle" data-label-off="No" data-label-on="Yes"></span>
                                        </label>
                                        </div>
                                    </div>
                                    </div>
                                </div>
                                <div className="mt-4">
                                    <div className="form-group">
                                        <div className="input-group input-group-alternative mb-3">
                                        <div className="input-group-prepend">
                                            <span className="input-group-text"><i className="ni ni-single-02"></i></span>
                                        </div>
                                        <input className="form-control" placeholder="Name on card" type="text" />
                                        </div>
                                    </div>
                                    <div className="form-group">
                                        <div className="input-group input-group-alternative mb-3">
                                        <div className="input-group-prepend">
                                            <span className="input-group-text"><i className="ni ni-credit-card"></i></span>
                                        </div>
                                        <input className="form-control" placeholder="Card number" type="text" />
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-6">
                                        <div className="form-group">
                                            <div className="input-group input-group-alternative mb-3">
                                            <div className="input-group-prepend">
                                                <span className="input-group-text"><i className="ni ni-calendar-grid-58"></i></span>
                                            </div>
                                            <input className="form-control" placeholder="MM/YY" type="text" />
                                            </div>
                                        </div>
                                        </div>
                                        <div className="col-6">
                                        <div className="form-group">
                                            <div className="input-group input-group-alternative">
                                            <div className="input-group-prepend">
                                                <span className="input-group-text"><i className="ni ni-lock-circle-open"></i></span>
                                            </div>
                                            <input className="form-control" placeholder="CCV" type="text" />
                                            </div>
                                        </div>
                                        </div>
                                    </div><br /><br />
                                      { enroll ? 
                                        <p className='text-white display-9'>You are Suscribed to this plan</p>
                                        : 
                                         upgrade &&  paysetup ? 
                                        <Button type="submit" className="btn btn-block btn-info bg-gradient-info" onClick={upgradeHandler}>Upgrade</Button>
                                            :
                                        paysetup ?
                                        <Button type="submit" className="btn btn-block btn-info bg-gradient-info" onClick={subscribeHandler}>Subscribe</Button>                                        
                                        :
                                        <p className='text-white display-9'></p>
                                    }
                                    <br /><br />
                                </div>
                                </div>
                                </div>
                            </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
  )
}

export default StudentsManage
